<header class="folder-header" (click)="toggleCollapsed()">
  <span class="material-symbols-outlined notranslate collapse-btn"
        [matTooltip]="(collapsed ? 'Expand sidebar' : 'Collapse sidebar') + ' ( [ )'"
        matTooltipPosition="right" [matTooltipShowDelay]="500">
    {{collapsed ? 'left_panel_open' : 'left_panel_close'}}
  </span>
  <span class="folder-title">Folders</span>
  <button class="folder-header-action" matTooltip="Add a new Folder" matTooltipPosition="right" [matTooltipShowDelay]="500"
          (click)="openCreateFolderPopup($event); $event.stopPropagation()">
    <i class="material-icons-outlined notranslate add-folder-icon">add</i>
  </button>
</header>

<ng-container *ngIf="loading">
  <div class="sidebar-main">
    <app-skeleton [style]="'folder-row'" [count]="4"></app-skeleton>
    <div class="folder-divider"></div>
    <app-skeleton [style]="'folder-row'" [count]="1"></app-skeleton>
  </div>
  <div class="archive-footer">
    <div class="folder-divider"></div>
    <app-skeleton [style]="'folder-row'" [count]="2"></app-skeleton>
  </div>
</ng-container>

<ng-container *ngIf="!loading">
  <div class="sidebar-main">
    <ul class="folder-list scrollable-container">
      <li class="folder-item"
          *ngFor="let folder of userFolders; trackBy: trackById"
          @appearFromAbove
          [ngClass]="{'active': folder.id === selectedFolderId}"
          [matTooltip]="folder.name" [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right" [matTooltipShowDelay]="500"
          (mouseenter)="hoveredFolderId = folder.id"
          (mouseleave)="hoveredFolderId = null"
          (click)="selectFolder(folder.id)">
        <i class="material-icons-outlined notranslate"
           [style.color]="(folder.id === selectedFolderId || folder.id === hoveredFolderId) ? null : folder.colour">
          {{ folder.id === selectedFolderId ? 'folder_open' : 'folder' }}
        </i>
        <span class="folder-label"
              [appTooltipOnTruncate]="folder.name" tooltipPosition="right">{{ folder.name }}</span>
        <button *ngIf="folder.id !== 'all'"
                class="folder-row-action"
                [matTooltip]="'Add rules to the ' + folder.name + ' folder'" matTooltipPosition="right" [matTooltipShowDelay]="500"
                (click)="openFolderPopup(folder, $event); $event.stopPropagation()">
          <i class="material-icons-outlined notranslate">add</i>
        </button>
        <span class="folder-badge"
              [matTooltip]="folder.count + ' rule' + (folder.count === 1 ? '' : 's') + ' in ' + folder.name"
              matTooltipPosition="right" [matTooltipShowDelay]="500">{{ folder.count }}</span>
      </li>
    </ul>

    <div class="folder-divider"></div>

    <ul class="folder-list scheduled">
      <li class="folder-system-item"
          [ngClass]="{'active': selectedFolderId === 'scheduled'}"
          [matTooltip]="'Scheduled Rules'" [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right" [matTooltipShowDelay]="500"
          (click)="selectFolder('scheduled')">
        <i class="material-icons-outlined notranslate">schedule</i>
        <span class="folder-label">Scheduled Rules</span>
        <span class="folder-badge"
              [matTooltip]="scheduledCount + ' rule' + (scheduledCount === 1 ? '' : 's') + ' in Scheduled Rules'"
              matTooltipPosition="right" [matTooltipShowDelay]="500">{{ scheduledCount }}</span>
      </li>
    </ul>

    <ng-container *ngIf="hasProductRules">
      <ul class="folder-list product-rules">
        <ng-container *ngFor="let folder of productFolders">
          <li class="folder-item"
              *ngIf="folder.count > 0"
              [ngClass]="{'active': folder.id === selectedFolderId}"
              [matTooltip]="folder.name" [matTooltipDisabled]="!collapsed"
              matTooltipPosition="right" [matTooltipShowDelay]="500"
              (click)="selectFolder(folder.id)">
            <i [class]="(folder.outlinedIcon ? 'material-icons-outlined' : 'material-icons') + ' notranslate'">{{ folder.icon }}</i>
            <span class="folder-label">{{ folder.name }}</span>
            <span class="folder-badge"
                  [matTooltip]="folder.count + ' rule' + (folder.count === 1 ? '' : 's') + ' for ' + folder.name"
                  matTooltipPosition="right" [matTooltipShowDelay]="500">{{ folder.count }}</span>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>

  <div class="archive-footer">
    <div class="folder-divider"></div>
    <ul class="folder-list">
      <li class="folder-system-item"
          *ngFor="let item of systemItems"
          [ngClass]="{'active': item.id === selectedFolderId, 'disabled': isSystemFolderDisabled(item)}"
          [matTooltip]="isSystemFolderDisabled(item) ? 'No rules have been archived' : (item.tooltip ?? item.name)"
          [matTooltipDisabled]="!isSystemFolderDisabled(item) && ((!item.tooltip && !collapsed) || hoveredBadgeId === item.id)"
          matTooltipPosition="right" [matTooltipShowDelay]="500"
          (click)="onSystemFolderClick(item)">
        <i class="material-icons-outlined notranslate">{{ item.icon }}</i>
        <span class="folder-label">{{ item.name }}</span>
        <span class="folder-badge"
              [matTooltip]="item.count + ' rule' + (item.count === 1 ? '' : 's') + ' in ' + item.name"
              matTooltipPosition="right" [matTooltipShowDelay]="500"
              (mouseenter)="hoveredBadgeId = item.id" (mouseleave)="hoveredBadgeId = null">{{ item.count }}</span>
      </li>
    </ul>
  </div>
</ng-container>

